var map = {
	"./addUser.webp": 2151,
	"./avatar.webp": 9676,
	"./avatar_square.webp": 2662,
	"./bell.webp": 576,
	"./boss.webp": 1228,
	"./clock.webp": 3409,
	"./coin.webp": 9748,
	"./copy.webp": 9988,
	"./deleteAccount.webp": 4361,
	"./divider.webp": 4570,
	"./empyCoin.webp": 373,
	"./eye_active.webp": 4485,
	"./friends.webp": 3286,
	"./hrGuruMan.webp": 8774,
	"./info.webp": 4873,
	"./language.webp": 5195,
	"./lightning.webp": 8249,
	"./menu_shadow.webp": 4375,
	"./minus.webp": 1303,
	"./money.webp": 9103,
	"./office.webp": 8981,
	"./plus.webp": 497,
	"./power.webp": 9218,
	"./redMarker.webp": 634,
	"./rocket.webp": 7193,
	"./settingsArrow.webp": 8933,
	"./settingsIcon.webp": 533,
	"./shop.webp": 8469,
	"./showInfo.webp": 9112,
	"./starIcon.webp": 9388,
	"./updateArrow.webp": 457
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6249;
module.exports = webpackAsyncContext;